import Search from "./Search";
import { useToursContext } from "./context"
import FilterForm from './FilterForm';
import React from "react";
import HiddenFields from "./HiddenFields";
import TourList from "../../../components/TourList";
import FiltersForm from "../../../components/ToursIndex/FiltersForm";
import { ReturnToFilters } from "../../../components/Shared";



import './styles/style.scss';





export function ToursIndex() {


    const {
        loading,
        context,
        page: { sortBy, orderByOptions, filterParams, request },
        location: { region, country, hasContent: locationHasContent, content: locationContent, background: locationBackground },
        tours: { tours, hasTours, toursToCount, totalTours, currentPage, totalPages, perPage, loadMoreTours, loadingTours, nextCount, get: getTours, tourListingCtaText, specificTours },
        agency,
        showLoader,
        measureProductClick,
        measureProductImpression,
        changeDurationRange,
        changePriceRange,
        changeRating,
        changeTourCategories,
        handleFormSubmit
    } = useToursContext();




    return (
        <div>
            <div className="view background-cover vh-55 black" style={{ backgroundImage: `url(${locationBackground})` }} >
                <div className="flex-center">
                    <div className="text-center">
                        <h2 className="mb-0">
                            <span className="font-meteoric white-text text-shadow-1">{region}</span>
                        </h2>
                        <h2><span className="font-meteoric white-text text-shadow-1">{country}</span></h2>
                    </div>
                </div>
            </div>




            <div className="container-fluid bottomvar-offset py-10 grey lighten-3">
                <div className="container p-0">

                    {locationHasContent && <div className="d-none d-lg-block" dangerouslySetInnerHTML={{ __html: locationContent }} />}

                    <div className="row mb-4 md-lg-0">
                        <div className="col-12 col-lg-9">
                            <FilterForm />

                            {!agency &&
                                <div className="row">
                                    <div className="col-12">
                                        <Search />
                                    </div>
                                </div>
                            }


                            {
                                hasTours &&

                                <div className="row mb-1">
                                    <div className="col-12 col-sm-6">
                                        <div className="mb-2 text-muted">
                                            <span className="mr-2">Viewing</span>1 - {toursToCount} of {totalTours}
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-6 text-sm-right">
                                        <ul className="list-inline mb-0">
                                            <li className="list-inline-item text-muted">
                                                Sort by
                                            </li>
                                            <li className="list-inline-item">
                                                <button className="btn btn-flat dropdown-toggle no-caret px-1" type="button" data-toggle="dropdown">
                                                    <span className="primary-text">{sortBy.display_as}<i className="fa fa-fw fa-angle-down ml-1"></i></span>
                                                </button>
                                                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">

                                                    <form onSubmit={showLoader}>
                                                        <HiddenFields omit={'search'} />

                                                        {
                                                            orderByOptions.data.map((orderByOption, key) => (
                                                                <button
                                                                    key={key}
                                                                    className="dropdown-item d-flex justify-content-between"
                                                                    name="sort_by"
                                                                    type="submit"
                                                                    value={orderByOption.slug}>
                                                                    <div className="mr-4">{orderByOption.display_as}</div>

                                                                    {
                                                                        orderByOption.slug == sortBy.slug &&
                                                                        <div><i className="fa fa-check text-success"></i></div>
                                                                    }
                                                                </button>
                                                            )
                                                            )
                                                        }
                                                    </form>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            }


                            {getTours().length > 0 ?
                                <TourList
                                    {...context}
                                    tours={getTours()}
                                    onImpressionChange={measureProductImpression}
                                    onProductClick={measureProductClick}
                                    tourListingCtaText={tourListingCtaText}
                                    specific_tours={specificTours}
                                />
                                :
                                <div className="row">
                                    <div className="col-12">
                                        <div className="media">
                                            <div className="align-self-start mr-3 d-none d-lg-block">
                                                <i className="fa fa-4x fa-exclamation-circle text-danger"></i>
                                            </div>
                                            <div className="media-body">
                                                <h2 className="d-none d-lg-block body-font font-weight-bold">
                                                    <span className="font-largest">We don’t have your exact match.</span>
                                                </h2>

                                                <h3 className="mb-4 d-lg-none body-font font-weight-bold">
                                                    <span className="font-largest">We don’t have your exact match.</span>
                                                </h3>

                                                <div className="font-larger mb-3">Try less filters to find the perfect experience.</div>

                                                <form onSubmit={showLoader}>
                                                    <button type="submit" className="btn btn-rounded btn-outline-four-b four-b-text m-0">
                                                        <span className="font-weight-bold mr-2">Reset filters</span><i className="fa fa-lg fa-undo"></i>
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                hasTours &&
                                <div className="row mb-1 justify-content-center">
                                    <div className="col-12 col-sm-6">
                                        <div className="text-center">
                                            <div className="mb-2 text-muted">
                                                <span className="mr-2">Viewing</span>1 - {toursToCount} of {totalTours}
                                            </div>

                                            {
                                                currentPage < totalPages &&
                                                <div>
                                                    <button
                                                        className="btn btn-primary btn-block py-4 mb-2"
                                                        type="button"
                                                        onClick={() => loadMoreTours(currentPage + 1)}>

                                                        <ul className="list-inline mb-0 d-flex align-items-center justify-content-center">
                                                            {
                                                                loadingTours &&
                                                                <li className="list-inline-item mr-3">
                                                                    <div className="spinner-border spinner-border-md d-block" role="status"></div>
                                                                </li>
                                                            }

                                                            <li className="list-inline-item">
                                                                {
                                                                    (totalTours - toursToCount) <= perPage ?
                                                                        <span className="font-weight-bold font-large">Show all remaining tours<i className="fa fa-lg fa-fw fa-angle-down ml-3"></i></span> :
                                                                        <span className="font-weight-bold font-large">Show the next {nextCount} tours<i className="fa fa-lg fa-fw fa-angle-down ml-3"></i></span>
                                                                }
                                                            </li>
                                                        </ul>
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        <div className="d-none d-lg-block col-lg-3" >
                            <div className="card border-0 rounded-0">
                                <div className="card-body">
                                    <div className="card-header white border-bottom px-0 pt-0">
                                        <form onSubmit={showLoader}>
                                            <button type="submit" className="btn btn-outline-dark btn-block text-uppercase d-flex justify-content-between font-smaller border-0 rounded-0">
                                                <div>Reset all filters</div>
                                                <div><i className="fa fa-times"></i></div>
                                            </button>
                                        </form>
                                    </div>

                                    <FiltersForm
                                        {...filterParams}
                                        changeDurationRange={changeDurationRange}
                                        changePriceRange={changePriceRange}
                                        changeRating={changeRating}
                                        changeTourCategories={changeTourCategories}
                                        request={request}
                                        sort_by={sortBy}
                                        submitFiltersForm={handleFormSubmit}
                                        tours={tours}
                                    />
                                </div>
                            </div>

                            <ReturnToFilters />
                        </div>
                    </div>


                    {
                        loading &&
                        <div className="view viewport-height position-fixed three-b opacity-75 w-100 z-max" style={{ left: 0, top: 0, bottom: 0, right: 0 }}>
                            <div className="progress md-progress primary-color z-3 mb-0">
                                <div className="indeterminate"></div>
                            </div>

                            <div className="mask d-flex justify-content-center align-items-center">
                                <div className="preloader-wrapper active crazy">
                                    <div className="spinner-layer spinner-red-only spinner-primary">
                                        <div className="circle-clipper left">
                                            <div className="circle"></div>
                                        </div>
                                        <div className="gap-patch">
                                            <div className="circle"></div>
                                        </div>
                                        <div className="circle-clipper right">
                                            <div className="circle"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {
                        locationHasContent &&
                        <div className="d-lg-none" dangerouslySetInnerHTML={{ __html: locationContent }} />
                    }
                </div>
            </div>




            <div className="d-lg-none d-xl-none" id="mobile-filter-options">
                <div className="filter-trigger-container">
                    <button className="btn btn-light shadow-lg" data-toggle="collapse" data-target="#mobile-filter-card" >
                        <div className="float-left">
                            <i className="fa fa-filter mr-2"></i>
                            <span>Refine Search</span>
                        </div>
                    </button>
                </div>



                <div id="mobile-filter-container">
                    <div id="mobile-filter-card" className="card collapse shadow-lg">
                        <div className="card-header bg-white border-0">
                            <div className="d-flex justify-content-between align-items-center border-bottom py-2">
                                <div><h4 className="font-weight-bold body-font px-2" >Refine Search</h4></div>
                                <button className="close" aria-label="Close" type="button" data-toggle='collapse' data-target="#mobile-filter-card">&times;</button>
                            </div>
                            <form onSubmit={showLoader}>
                                <button type="submit" className="btn btn-outline-dark btn-block text-uppercase d-flex justify-content-between font-smaller border-0 rounded-0">
                                    <div>Reset all filters</div>
                                    <div><i className="fa fa-times"></i></div>
                                </button>
                            </form>
                        </div>
                        <div className="card-body scrollable p-4 px-0" >
                            <FiltersForm
                                {...filterParams}
                                changeDurationRange={changeDurationRange}
                                changePriceRange={changePriceRange}
                                changeRating={changeRating}
                                changeTourCategories={changeTourCategories}
                                request={request}
                                sort_by={sortBy}
                                submitFiltersForm={handleFormSubmit}
                                tours={tours}
                            />
                        </div>
                    </div>
                </div>

            </div>




        </div>
    )
}


// WEBPACK FOOTER //
// ./resources/js/react/components/ToursIndex/ToursIndex.jsx